import { versionCompare } from '@kibt/web-utils/version';
import Cookies from 'js-cookie';
import { kpn } from './device';
export function isIOS() {
  var inBrowser = typeof window !== 'undefined';
  var UA = inBrowser && window.navigator.userAgent.toLowerCase();
  return UA && /iphone|ipad|ipod|ios/.test(UA);
}
export function isAndroid() {
  var inBrowser = typeof window !== 'undefined';
  var UA = inBrowser && window.navigator.userAgent.toLowerCase();
  return UA && UA.indexOf('android') > 0;
}
export var getAppType = function getAppType() {
  var apptype;

  if (kpn === 'KWAI') {
    if (isIOS()) {
      apptype = 3;
    } else {
      apptype = 25;
    }
  } else if (kpn === 'KWAI.ME') {
    if (isIOS()) {
      apptype = 12;
    } else {
      apptype = 36;
    }
  } else if (isIOS()) {
    apptype = 11;
  } else {
    apptype = 32;
  }

  return apptype;
}; // 后端通用参数，但是在端外没有

export var getClientType = function getClientType() {
  return isIOS() ? 1001 : 2003;
};
export var disableWebp = isIOS() && versionCompare(Cookies.get('os') || '', '13.7') <= 0;